module.exports = __webpack_public_path__ + "img/4.310ca54.png";